import { acceptHMRUpdate, defineStore } from "pinia";
import type { TabPaneName, TabsPaneContext } from 'element-plus';

interface tabInterface {
  title: string;
  name: string | number;
  disabled: boolean;
}


export const useTagStore = defineStore("tag", () => {
  const editableTabs = ref<tabInterface[]>([
    {
      title: '首页',
      name: '/home',
      disabled: false,
    },
  ]);
  const editableTabsValue = ref<string | number>('');
  const removeTab = async (targetName: TabPaneName) => {
    const menu = useMenuStore();
    const tabs = editableTabs.value;
    let activeName = editableTabsValue.value;
    if (activeName === targetName) {
      tabs.forEach((tab, index) => {
        if (tab.name === targetName) {
          const nextTab = tabs[index + 1] || tabs[index - 1]
          if (nextTab) {
            activeName = nextTab.name;
          }
        }
      })
    }
    editableTabsValue.value = activeName;
    await navigateTo(activeName as string);
    const { active } = storeToRefs(menu);
    active.value = activeName as string;
    editableTabs.value = tabs.filter((tab) => tab.name !== targetName);
  }
  const addTab = (targetName: TabPaneName, title: string) => {
    console.log("targetName", targetName);
    const tabs = editableTabs.value;
    let tab = tabs.find(p => p.name == targetName);
    if(tab) {
      editableTabsValue.value = targetName;
    } else {
      tabs.push({ title: title, name: targetName, disabled: true });
      editableTabsValue.value = targetName;
    }
  }
  const clickTab = async (pane: TabsPaneContext, ev: Event) => {
    const menu = useMenuStore();
    const { active } = storeToRefs(menu);
    active.value = pane.paneName as string;
    await navigateTo(pane.paneName as string)
  }
  return {
    clickTab,
    addTab,
    removeTab,
    editableTabsValue,
    editableTabs,
  };
})

if (import.meta.hot)
  import.meta.hot.accept(acceptHMRUpdate(useTagStore, import.meta.hot));
